export const connectNativeAudioNodeToNativeAudioNode = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input) => {
    const inputs = nativeDestinationAudioNode.inputs;
    if (inputs !== undefined) {
        nativeSourceAudioNode.connect(inputs[input], output, 0);
        return [inputs[input], output, 0];
    }
    nativeSourceAudioNode.connect(nativeDestinationAudioNode, output, input);
    return [nativeDestinationAudioNode, output, input];
};
//# sourceMappingURL=/build/es2018/helpers/connect-native-audio-node-to-native-audio-node.js.map